<template>
<v-dialog v-model="popup.show" max-width="500px" transition="slide-y-reverse-transition" persistent scrollable>
  <v-card>
    <v-card-title class="pa-0">
      <v-toolbar class="pl-2" color="transparent" flat>
        <v-spacer></v-spacer>
        <v-toolbar-title class="headline ml-4">{{popup.type}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          @click.native="popup.show = false"
          icon
          flat
        ><v-icon>close</v-icon></v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex v-if="popup.type == 'Resetting'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">You will lose all unsaved changes</div>
          <div class="subheading pb-3">Are you sure?</div>
          <div>
            <v-btn @click.native="broadcast('reset')" color="error" depressed>Reset</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Creating Course' || popup.type == 'Updating Course'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">
            <b>{{newC.type}}</b> course <b>{{newC.name}}</b> will be {{popup.type == 'Creating Course' ? 'created.' : 'updated.'}}
          </div>
          <div>
            <v-btn
              @click.native="broadcast(popup.type == 'Creating Course' ? 'createCourse' : 'updateCourse')"
              color="success"
              depressed
            >{{popup.type == 'Creating Course' ? 'Create' : 'Update'}}</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Publishing' || popup.type == 'Unpublishing'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">{{popup.type}} <b>{{newC.name}}</b></div>
          <div class="subheading pb-3">Continue?</div>
          <div>
            <v-btn
              @click.native="broadcast(popup.type == 'Publishing' ? 'publish' : 'unpublish')"
              :color="popup.type == 'Publishing' ? 'success' : 'error'"
              depressed
            >{{popup.type == 'Publishing' ? 'Publish' : 'UnPublish'}}</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Add Student'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">
            <span>Adding <b>{{studentD.firstName + ' ' + studentD.lastName}}</b></span>
            <span> from <b>{{newC.name}}</b></span>
          </div>
          <div class="subheading pb-2">
            <span>This will create a new progress for the student</span>
          </div>
          <div class="subheading pb-3">Continue?</div>
          <div>
            <v-btn
              @click.native="broadcast('addStudent')"
              color="success"
              depressed
            >Add</v-btn>
          </div>
        </v-flex>
        <v-flex v-if="popup.type == 'Remove Student'" xs12 class="text-xs-center px-3 pb-3 pt-1">
          <div class="subheading pb-2">
            <span>Removing <b>{{studentD.firstName + ' ' + studentD.lastName}}</b></span>
            <span> from <b>{{newC.name}}</b></span>
          </div>
          <div class="subheading pb-2">
            <span>This will stop the student from having access to the course</span>
          </div>
          <div class="subheading pb-3">Continue?</div>
          <div>
            <v-btn
              @click.native="broadcast('removeStudent')"
              color="error"
              depressed
            >Remove</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
import {coursesEvent} from '../../main'
export default {
  props: ['popup', 'newCourse', 'studentData', 'deletingData'],
  computed: {
    newC () {
      return this.newCourse ? this.newCourse : {}
    },
    studentD () {
      return this.studentData ? this.studentData : {}
    },
    deletingD () {
      return this.deletingData ? this.deletingData : {}
    }
  },
  methods: {
    broadcast (event) {
      coursesEvent.$emit(event)
      this.popup.show = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/CoursePopup.vue